<template>
    <div >
        <myHeader></myHeader>
        <div class='loginBg'>
        <div class='loginBox'>
            <div class="choseSf">
                <p>请选择身份登录</p>
                <ul>
                    <li 
                    :class='{active:role==item.id}' 
                    v-for="(item,index) in userSf" 
                    :key='index'
                    >{{item.lx}}</li>
                </ul>
            </div>
            <div class="formBox">
                <ul>
                    <li 
                    :class='{active:activeAccount==item.id}' 
                    v-for="item in accounts" 
                    :key='item.id'
                    >
                    {{item.name}}
                    </li>
                </ul>
               
                <!-- 账号登录 -->
                <div>
                    <div class='errorMsg'>
                        <p>{{errorMsg}}</p>
                    </div>
                    <el-input class='account' v-model='username' placeholder="用户名"></el-input>
                    <el-input class='password' type="password" v-model="password" placeholder="密码" @keyup.enter.native="loginZh()"></el-input>
                    <el-button class='loginBtn' type="primary" @click='loginZh()'>登录</el-button>
                </div>
                <!-- 扫码登录 -->
                
            </div>
        </div>
        <p class='jszc'>
            技术支持:浙江招天下招投标交易平台有限公司
        </p>
        </div>
    </div>
</template>
<script>
import myHeader from '../components/header'
export default {
    name:'login',
    components:{
        myHeader
    },
    data(){
        return{
            userSf:[{lx:'系统管理员',id:'M'}],//,
            role:'M',//当前角色
            accounts:[{name:'账号登录',id:'zh'}],
            activeAccount:'zh',//当前登录方式
            caList:[],//ca
            username:'',
            password:'',
            errorMsg:'',//错误提示内容
        }
    },
    methods:{
        //账号登录
        loginZh(){
            let para={
                username:this.username,
                password:this.password,
                role:this.role
            }
            this.$api.loginZh(para).then(res=>{
                if(res.data.meta.success){
                    this.$message({
                        message: res.data.data.msg,
                        type: 'success'
                    });
                    localStorage.setItem("user",res.data.data.qymc); 
                    localStorage.setItem("jgdm",res.data.data.jgdm);
                    localStorage.setItem("role",this.role); 
                    this.$router.push("/adminIndex");
                    
                }else{
                    this.$message({
                        message: res.data.meta.message,
                        type: 'error'
                    });
                }
            }).catch(()=>{
                this.$message({
                    message: '请求出错',
                    type: 'error'
                });
            })
        },
    },
    mounted(){}
}
</script>